module.exports = __webpack_public_path__ + "img/guang.0ecb1a6d.svg";